module.exports = __webpack_public_path__ + "img/dgcsj.b647fd46.png";